import { inject, OnInit } from '@angular/core';
import { filter } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { E_FOLDER_TYPES, E_URL_PARTS } from '@shared/constants/enums.const';


@UntilDestroy()
export class BaseComponent implements OnInit {
  pageData: any;
  protected readonly router: Router = inject(Router);

  constructor() {
  }

  get isHome(): boolean {
    const urlArr = this.getUrlArray();
    return urlArr.length > 1 && urlArr[E_URL_PARTS.rootFolder].toLowerCase() === E_FOLDER_TYPES.Home.toLowerCase();
  }

  getUrlArray(): string[] {
    return this.router.url
      .split('?')[0]
      .split('/').slice(1);
  }

  ngOnInit() {
    this.router.events
      .pipe(
        untilDestroyed(this),
        filter(event => event instanceof NavigationEnd),
      )
      .subscribe(() => {
        this.onReload();
      });
  }


  onReload(): void {
    this.pageData = undefined;
    this.getData();
  }

  getData(): void {
  }

}
